module.exports = __webpack_public_path__ + "img/Light Status.4a315e8c.png";